import 'jquery-viewport-checker';

import 'owl.carousel';
//import OwlCarousel from '../../src/js/custom/owl-carousel.js'
//Carousel
import MainCarousel from '../../src/js/custom/owl-carousel.js';

import 'popper.js';
import 'bootstrap';


//import 'jscrollpane';
//import 'jquery-mousewheel';
//import 'malihu-custom-scrollbar-plugin';
import 'url-search-params-polyfill';
import 'readmore-js';

import main_menu from '../../src/js/custom/main_menu.js';

//import Visibility from '../../src/js/custom/visibility.js'
import ManualSlider from '../../src/js/custom/manual-slider.js'
import VideoBg from '../../src/js/custom/video-bg.js'
import YouTubeCustom from '../../src/js/custom/youtube-player.js'
import CustomTable from '../../src/js/custom/custom-table.js'
import Alphabet from '../../src/js/custom/alphabet.js'
import CountryAutocomplete from '../../src/js/custom/autocomplete.js'
import BlockModal from '../../src/js/custom/block-modal.js'
import ScrollTopLink from '../../src/js/custom/scroll-top-link.js'
//import CustomScrollbar from '../../src/js/custom/custom-scrollbar.js'
import RadialChart from '../../src/js/custom/radial-chart.js'
import RequestCallBack from '../../src/js/custom/request-call-back.js'
import ExpandCardText from '../../src/js/custom/expand-card-text.js'
import RefTooltip from '../../src/js/custom/ref-tooltip.js'
import GTM from '../../src/js/custom/gtm.js'
import FaqPage from '../../src/js/custom/faq-page.js'
import RelatedSelect from '../../src/js/custom/pl-refund-page.js'
//Simplebar Scrollbar
import SimpleBar from 'simplebar';

(function () {
    window.SimpleBar = SimpleBar;
})();

jQuery(document).ready(function($){
    
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    if ($('.open-popup').length > 0) {
        $('.open-popup').first().modal('show');
    }

    //show popup e-learn
    if ($('.layout-builderoverridesnodeview').length == 0 && $('#e-learn-popup').length > 0) {
        var eLearnCookieName = 'eLearnAccept';  
        var eLearnCookie = getCookie(eLearnCookieName);
        if (eLearnCookie == undefined) {   
            $('#e-learn-popup').modal({
                backdrop: 'static',
                keyboard: false
            })
        }
    }

    if ($('.layout-builderoverridesnodeview').length == 0 && $('#privacy-popup').length > 0) {
        var eLearnCookieName = 'privacyAccept';  
        var eLearnCookie = getCookie(eLearnCookieName);
        if (eLearnCookie == undefined) {   
            $('#privacy-popup').modal({
                backdrop: 'static',
                keyboard: false
            })
        }
    }

    // get cookie
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    $('.paragraph--type--mdt-alert .close').click(function(){
        $(this).parent('.paragraph--type--mdt-alert').removeClass('show');
    });

    var closeMenu = function () {
       $('.navbar-collapse').collapse("hide");
    };

    $('.navbar-collapse').on('show.bs.collapse', function() {
        closeSearch();
        $('body').addClass('show-mobile-menu');
    });

    $('.navbar-collapse').on('hide.bs.collapse', function() {
        $('body').removeClass('show-mobile-menu');
    });

    $('.open-search .nav-link').on('click', function (e) {
        e.preventDefault();
        closeMenu();
        $('.open-search').toggleClass('opened');
        $('#navbar-search').slideToggle();
    })

    var closeSearch = function () {
        $('.open-search').removeClass('opened');
        $('#navbar-search').slideUp();
    }

    let currentWidth = $(window).width();
    let morebtn = Drupal.t('Learn more');
    let lessbtn = Drupal.t('Close');
    if ( $('.readmore').length > 0 ) {

        let rmactive = false;

        let readoptions = {
            embedCSS: false, 
            moreLink: '<a href="#" class="readmore-link readmore-more-link">'+morebtn+'</a>',
            lessLink: '<a href="#" class="readmore-link readmore-less-link">'+lessbtn+'</a>',
            speed: 100,
        };
        
        if (currentWidth < 768) {
          $('.readmore').readmore(readoptions);
          rmactive = true;
        };
        
        $(window).resize(function(e) {
            let winwidth = window.innerWidth;
            if (winwidth < 768 && !rmactive) {
                $('.readmore').readmore(readoptions);
                rmactive = true;
            } else if (winwidth >= 768 && rmactive) {
                $('.readmore').readmore('destroy');
                rmactive = false;
            }
        });
    };

   $('.js-screenOver').viewportChecker({
        classToAdd:'screen-visible',
        repeat:true,
        offset:'45%',
        invertBottomOffset:true
    });

    $('.js-screenAnimate').viewportChecker({
        classToAdd:'screen-animate',
        repeat:false,
        offset:'30%',
        invertBottomOffset:true
    });

    $('.js-screenVisible').viewportChecker({
        repeat:true,
        //offset:'30px',
        //invertBottomOffset:true
    });

    $('.collapse:not(.acc-collapse)').on('shown.bs.collapse', function(e) {
        var card = $(this).closest('.card');
        if (card.length > 0 && !card.hasClass('card-main')) {
            $('html,body').stop(true, false).animate({
                scrollTop: card.offset().top
            }, 500);
        };
    });

    $('.collapse.acc-collapse').on('shown.bs.collapse', function(e) {
        var hidelnk = $(this).find('.accord-hide-text');
        var idcard = hidelnk.attr('data-card-id');
        $('html,body').stop(true, false).animate({
            scrollTop: $(idcard + ' .card-body').offset().top - 100
        }, 500);
    });

    $('.collapse.acc-collapse').on('show.bs.collapse', function(e) {
        var hidelnk = $(this).find('.accord-hide-text');
        var idhead = hidelnk.attr('data-head-id');
        $(idhead).hide();
    });

    $('.collapse.acc-collapse').on('hidden.bs.collapse', function(e) {
        var hidelnk = $(this).find('.accord-hide-text');
        var idhead = hidelnk.attr('data-head-id');
        $(idhead).show();
        var idcard = hidelnk.attr('data-card-id');
        $('html,body').stop(true, false).animate({
            scrollTop: $(idcard).siblings('.accordeon-preview').offset().top - 100
        }, 500);
    });

    //Popup modal card
    var modalpblock = null;

    $('.popup-modal-card').on('show.bs.modal', function (e) {
        $(this).find('.close').css('top', '-3px');
        if ($(this).parents('.block.d-none').length > 0) {
            modalpblock = $(this).parents('.block.d-none');
            modalpblock.removeClass('d-none');
        } else {
            modalpblock = null;
        }
        if ($(this).hasClass('paragraph--type--mdt-mdi-module-cards-result') && (window.dataLayer = window.dataLayer || [])) {
            var title_product = $(this).find('.mdi-close-result').attr('data-title-gtm');
            dataLayer.push({'event':'gaView','virtualPagePath':'/result','virtualPageTitle':title_product});
        }
    });

    if (document.body.classList.contains('mdi-main-page')) {
        $('.paragraph--type--mdt-mdi-module-cards-result').on('click','.close',function(e){
            dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'result', 'eventLabel':'close popup'});
        });
    }

    $('.popup-modal-card').on('.bs.modal', function (e) {
        if ( modalpblock != null)  {
            modalpblock.addClass('d-none');
        }
    });

    $('.popup-modal-card').on('hidden.bs.modal', function () {
        history.replaceState({}, document.title, window.location.href.split('#')[0]);
    });

    $('.popup-modal-card').on('scroll', function() {
        $('.popup-modal-card.show').each(function() {
          var mdialog = $(this).find('.modal-dialog');
          var thisTop = $(this).offset().top - mdialog.offset().top;
          if (thisTop > -24) {
            $('.popup-modal-card.show .close').css('top', thisTop + 21 + 'px');
          } else {
            $('.popup-modal-card.show .close').css('top', '-3px');
          }
        });
    });

    $('.square-blocks').each(function(index_1){
        var blocks = $(this).find('.layout__region > .block');
        var c_blocks = blocks.length;
        if (c_blocks >= 3) {
            if (c_blocks > 6) {
                $(this).append('<div class="wrap-view-more-link"><a class="view-more" href="#" onclick="SquareViewMore(\'.sq-blocks-'+index_1+'\', jQuery(this)); return false;">' + Drupal.t('View More') + '</a></div>');
            } else if (c_blocks >= 3) {
                $(this).append('<div class="wrap-view-more-link d-lg-none d-xl-none"><a class="view-more" href="#" onclick="SquareViewMore(\'.sq-blocks-'+index_1+'\', jQuery(this)); return false;">' + Drupal.t('View More') + '</a></div>');
            }
            blocks.each(function( index_2 ){
                if (index_2 >= 3 && index_2 <= 5) {
                    $(this).addClass('d-none d-lg-block d-xl-block sq-blocks-'+index_1);
                } else if (index_2 > 6) {
                    $(this).addClass('d-none desk-hide sq-blocks-'+index_1);
                };
            });
        };
    });

    if (window.location.hash) {
        var hash = window.location.hash;
        if ($(hash).hasClass('modal')){
            $(hash).modal('toggle');
        };
    }

    // Add country parametr to FA896 language switcher links
    if ($('.language-dropdown').length > 0) {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var country = url.searchParams.get("country");
        if (country != undefined && country != null) {
            $('.language-dropdown a.dropdown-item').each(function(){
                var uri = $(this).attr('href');
                $(this).attr('href', uri + '?country=' + country);
            });
            if (!(country == 'CY' || country == 'KE')) {
                $('.language-dropdown').removeClass('d-none');
            }
        }
    }

    $('#top-header').on('click','.languageswitcher .is-active a', function(e){
        e.preventDefault();
    });

    $('#top-header').on('click','.languageswitcher ul.links', function(e){
        $(this).toggleClass('opened');
    });

    $('.language-picker ul.language-switcher-locale-url').on('click', function () {
        $(this).toggleClass('opened');
    });

    $('.half-image-block.more-height .img-fluid').each(function(){
        objectFit($(this).get(0));
    });

    /*function makeid(length) {
        var result           = [];
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result.push(characters.charAt(Math.floor(Math.random() * 
          charactersLength)));
       }
       return result.join('');
    }*/
   
    $('#appCompatibilityLink, .appCompatibilityLink').on('click', function(){
        var appCampatibilityCardId = $('#appCompatibility').closest('.card-body').parent().attr('id');
        $('#'+appCampatibilityCardId).collapse("show");
    });
  
});

window.inViewport = function(el) {
    var r, html;
    if ( !el || 1 !== el.nodeType ) { return false; }
    html = document.documentElement;
    r = el.getBoundingClientRect();
    return ( !!r
      && r.bottom >= 0
      && r.right >= 0
      && r.top <= html.clientHeight
      && r.left <= html.clientWidth
    );
};

window.SquareViewMore = function(classblocks, el) {
    var fhblock_mob = jQuery(classblocks + '.d-none.d-lg-block').eq(0);
    var fhblock_desk = jQuery(classblocks + '.desk-hide').eq(0);
    jQuery(classblocks).removeClass('d-none');
    el.parent().remove();
    if (window.innerWidth < 992) {
        if (fhblock_mob.length > 0) {
            jQuery('html,body').stop(true, false).animate({
                scrollTop: fhblock_mob.offset().top - 100
            }, 500);
        }
    } else {
        if (fhblock_desk.length > 0) {
            jQuery('html,body').stop(true, false).animate({
                scrollTop: fhblock_desk.offset().top - 100
            }, 500);
        }
    }
};

window.scrollToBlock = function(idblock) {
    var scrblock = jQuery('#'+idblock);
    if (scrblock.length > 0) {
        jQuery('html,body').stop(true, false).animate({
            scrollTop:scrblock.offset().top - 100
        }, 500);
    }
};

window.objectFit = function(image) {
    if ('objectFit' in document.documentElement.style === false && image.currentStyle['object-fit']) {
        image.style.background = 'url("' + image.src + '") no-repeat 50%/' + image.currentStyle['object-fit'];
        image.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + image.width + "' height='" + image.height + "'%3E%3C/svg%3E";
    }
};

// set cookie
window.setCookie = function(name, value, exhours) {
    var d = new Date();
    // add cookie expiry date to be one hour from the current time
    d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    // Pass the name, cookie value and expiry time into the cookie
    document.cookie = name + "=" + value + ";" + expires + '; path= /';
}